import { render, staticRenderFns } from "./button-bubble-bl.vue?vue&type=template&id=1fd1d674&scoped=true&"
var script = {}
import style0 from "./button-bubble-bl.vue?vue&type=style&index=0&id=1fd1d674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd1d674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd1d674')) {
      api.createRecord('1fd1d674', component.options)
    } else {
      api.reload('1fd1d674', component.options)
    }
    module.hot.accept("./button-bubble-bl.vue?vue&type=template&id=1fd1d674&scoped=true&", function () {
      api.rerender('1fd1d674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-bubble-bl.vue"
export default component.exports